"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-thirteen/sections/serviceSliderThirteen.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { FC, ComponentProps } from "react";

export type HomeThirteenServiceSliderThirteenGeneratedProps = {
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    sectionDiv0Swiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
    sectionDiv1Swiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
};

const HomeThirteenServiceSliderThirteenGenerated: FC<HomeThirteenServiceSliderThirteenGeneratedProps> = ({
    sectionDataWowDuration = "1s",
    sectionDiv0Swiper0SwiperProps,
    sectionDiv1Swiper0SwiperProps,
}) => {
    return (
        <section className="slider-section slider-section-thirteen wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <div className="horizontal-slide slide-one slide-thirteen bg-primary d-flex">
                <Swiper modules={[Autoplay]} slidesPerView={"auto"} spaceBetween={16} loop={true} autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                }} speed={10000} allowTouchMove={false} {...(sectionDiv0Swiper0SwiperProps ?? {})}></Swiper>
            </div>
            <div className="horizontal-slide slide-two slide-thirteen two d-flex">
                <Swiper modules={[Autoplay]} slidesPerView={"auto"} spaceBetween={16} loop={true} autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                    reverseDirection: true,
                    pauseOnMouseEnter: false,
                }} speed={10000} allowTouchMove={false} {...(sectionDiv1Swiper0SwiperProps ?? {})}></Swiper>
            </div>
        </section>
    );
};

export default HomeThirteenServiceSliderThirteenGenerated;
